// iach-custom-scripts.js
// ---------------------------------------------------
// Custom JavaScript for theme overrides and added functionality.
// Use namespaced code (e.g., window.iachCustom) to avoid conflicts.
// Keep functions modular, comment logic, and test across browsers.
// Do not hard-code sensitive data. Loaded via iach-custom-scripts.liquid.
// ---------------------------------------------------

window.iachCustom = window.iachCustom || {}

window.iachCustom.logLoaded = function () {
  console.log('iach-custom-scripts.js has loaded!')
}

/* ------------------- Custom Cart Icon Functions ---------*/

/**
 * Keep the cart icon badge in sync with cart state
 * Listens globally for `cartUpdate` events and updates the badge in the header.
 */
window.iachCustom.initCartBadgeUpdater = function () {
  document.addEventListener('cartUpdate', function(event) {
    let itemCount =
      event.detail?.resource?.item_count ??
      event.detail?.data?.itemCount ??
      event.detail?.cart?.item_count;

    function updateBadge(count) {
      document.querySelectorAll('.cart-bubble').forEach(function(bubble) {
        // Show/hide bubble container itself
        if (count > 0) {
          bubble.classList.remove('visually-hidden'); // <-- remove the container's visually-hidden
        } else {
          bubble.classList.add('visually-hidden');
        }
    
        // Handle the inner count
        var countEl = bubble.querySelector('.cart-bubble__text-count');
        if (countEl) {
          if (count > 0) {
            countEl.classList.remove('hidden');
            countEl.textContent = count;
          } else {
            countEl.classList.add('hidden');
            countEl.textContent = '';
          }
        }
      });
    }

    if (typeof itemCount === 'number') {
      updateBadge(itemCount);
    } else {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => updateBadge(cart.item_count));
    }
  });
};

/* ------------------- Sticky Header ---------*/

const siteBody = document.querySelector(".page-body");
const stickyHeader = document.getElementById('site-header');

let oldValue = 0;
let newValue = 0;

// Debounce limits how often the scroll function fires
function debounce(method, delay) {
  clearTimeout(method._tId);
  method._tId = setTimeout(function() {
    method();
  }, delay);
}

function scrollFunction() {
  
  if (siteBody.classList.contains('site-header-force-visible')) {
    return;
  }
  
  newValue = window.pageYOffset;
  if (oldValue < newValue) {
    
    if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {
      
      siteBody.classList.add("page-scrolled");
      
    }
    
    if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {

      // We are more than 150px down the page so lets hide the header

      // console.log("Scrolling Down > 150");

      siteBody.classList.add("site-header-hidden");
      

    } else {

      // We are close to the top and scrolling down so let's just keep the header in view for now (do nothing)

      // console.log("Scrolling Down < 150");

    }


  } else if (oldValue > newValue) {

    if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {

      // We are more than 150px down the page and the user is scrolling up, lets show the header

      // console.log("Scrolling Up > 150");

      siteBody.classList.remove("site-header-hidden");

    } else {

      // We are close to the top, let's show the header

      // console.log("Scrolling Up < 150");

      siteBody.classList.remove("site-header-hidden");
      siteBody.classList.remove("page-scrolled");

    }



  }

  oldValue = newValue;


}

window.iachCustom.initStickyHeader = function () {
  
  // Test to see if when the page initially loads we are at the top, if not lets hide the header
  console.log(window.pageYOffset);
  
  if(window.pageYOffset > 200){
    // transparent header shouldnt be transparent if the page loads and it isnt at the top
  }
  
  //pageBodyForStickyHeader.classList.add('page-site-header-sticky');
  
  window.onscroll = function() {
    debounce(scrollFunction, 100);
  };
  
}

/* ------------------- End Sticky Header ---------*/


window.iachCustom.lazyloadBGimage = function () {
  const lazyBGs = document.querySelectorAll('.lazyload-bgimage')

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target
          const src = el.getAttribute('data-img-src')
          if (src) {
            const img = new Image()
            img.onload = () => {
              el.style.backgroundImage = `url("${src}")`
              el.classList.add('lazyloaded')
            }
            img.src = src
            obs.unobserve(el)
          }
        }
      })
    })

    lazyBGs.forEach((el) => observer.observe(el))
  } else {
    // fallback: load immediately
    lazyBGs.forEach((el) => {
      const src = el.getAttribute('data-img-src')
      if (src) el.style.backgroundImage = `url("${src}")`
    })
  }
}

window.iachCustom.playVideo = function () {
  const playButtons = document.querySelectorAll(
    '.iach-video-player .btn-play, .iach-video-player .overlay-div'
  )

  playButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const videoSrc = this.parentNode.getAttribute('data-video-src')
      console.log(videoSrc)
      if (!videoSrc) return

      const autoplaySrc = videoSrc.includes('?')
        ? videoSrc + '&autoplay=1'
        : videoSrc + '?autoplay=1'

      // creating iframe dynamically to avoid page render blocking
      const iframe = document.createElement('iframe')
      iframe.src = autoplaySrc
      iframe.allow = 'autoplay; encrypted-media'
      iframe.allowFullscreen = true
      iframe.frameBorder = '0'
      iframe.style.width = '100%'
      iframe.style.height = '100%'

      const wrapper = this.closest('.iach-video-player')
      wrapper.innerHTML = ''
      wrapper.appendChild(iframe)
    })
  })
}


// Acknowledgment Popup Functionality
window.iachCustom.initAcknowledgmentPopup = function () {
  const popup = document.getElementById('acknowledgment-popup')
  const closeBtn = document.querySelector('.acknowledgment-popup__close')
  const acceptBtn = document.getElementById('acknowledgment-accept')
  const overlay = document.querySelector('.acknowledgment-popup__overlay')

  if (!popup) return

  const STORAGE_KEY = 'iach_acknowledgment_accepted'
  const hasAccepted = localStorage.getItem(STORAGE_KEY)

  // Show popup if user hasn't accepted before
  if (!hasAccepted) {
    // Small delay to ensure page is loaded
    setTimeout(() => {
      popup.style.display = 'flex'
      document.body.style.overflow = 'hidden'
    }, 500)
  }

  function closePopup() {
    popup.classList.add('hidden')
    document.body.style.overflow = ''

    // Store acceptance in localStorage
    localStorage.setItem(STORAGE_KEY, 'true')

    // Remove from DOM after animation
    setTimeout(() => {
      popup.style.display = 'none'
    }, 300)
  }

  function handleAccept() {
    closePopup()
  }

  function handleClose() {
    closePopup()
  }

  function handleOverlayClick(e) {
    if (e.target === overlay) {
      closePopup()
    }
  }

  function handleEscapeKey(e) {
    if (e.key === 'Escape' && popup.style.display === 'flex') {
      closePopup()
    }
  }

  // Event listeners
  if (acceptBtn) {
    acceptBtn.addEventListener('click', handleAccept)
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', handleClose)
  }

  if (overlay) {
    overlay.addEventListener('click', handleOverlayClick)
  }

  document.addEventListener('keydown', handleEscapeKey)
}

// AJAX Contact Form Functionality
window.iachCustom.initAjaxContactForm = function () {
  console.log('Initializing AJAX contact form...')
  const contactForm = document.getElementById('contact_form')
  const messagesContainer = document.getElementById('contact-form-messages')

  console.log('Contact form found:', contactForm)
  console.log('Messages container found:', messagesContainer)

  if (!contactForm || !messagesContainer) {
    console.log(
      'Contact form or messages container not found, skipping AJAX initialization'
    )
    return
  }

  // Change form action to prevent default submission
  contactForm.action = 'javascript:void(0)'
  contactForm.setAttribute('data-ajax-form', 'true')
  console.log('Form action changed to prevent default submission')

  function showMessage(message, isError = false) {
    console.log('Showing message:', message, 'isError:', isError)
    const messageClass = isError
      ? 'p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg'
      : 'p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg'

    messagesContainer.innerHTML = `<div class="${messageClass}"><p class="text-center font-medium">${message}</p></div>`
    messagesContainer.style.display = 'block'
    console.log('Message displayed in container')

    // Scroll to top of form to show message
    contactForm.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  function showErrors(errors) {
    let errorHtml =
      '<div class="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg"><ul class="errors">'

    for (const field in errors) {
      errorHtml += `<li class="text-sm">${
        field.charAt(0).toUpperCase() + field.slice(1)
      } - ${errors[field]}</li>`
    }

    errorHtml += '</ul></div>'
    messagesContainer.innerHTML = errorHtml
    messagesContainer.style.display = 'block'

    // Scroll to top of form to show errors
    contactForm.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  function hideMessage() {
    messagesContainer.style.display = 'none'
    messagesContainer.innerHTML = ''
  }

  function setSubmitButtonLoading(isLoading) {
    const submitBtn = contactForm.querySelector('button[type="submit"]')
    if (!submitBtn) return

    if (isLoading) {
      submitBtn.disabled = true
      submitBtn.innerHTML = 'Sending...'
      submitBtn.classList.add('opacity-75', 'cursor-not-allowed')
    } else {
      submitBtn.disabled = false
      submitBtn.innerHTML = 'Submit'
      submitBtn.classList.remove('opacity-75', 'cursor-not-allowed')
    }
  }

  // AJAX submission handler
  async function handleAjaxSubmission() {
    console.log('Handling AJAX submission')

    // AJAX is working - no more alerts needed!

    // Hide any previous messages
    hideMessage()

    // Show loading state
    setSubmitButtonLoading(true)

    try {
      const formData = new FormData(contactForm)
      console.log('Form data prepared:', formData)

      console.log('Sending AJAX request to /contact')
      const response = await fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
        },
      })

      console.log('Response received:', response.status, response.statusText)
      const responseText = await response.text()
      console.log('Response text:', responseText)

      // Create a temporary div to parse the response
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = responseText

      // Check for success message
      const successMessage = tempDiv.querySelector(
        '.success-message, [class*="success"]'
      )
      if (successMessage) {
        showMessage("Thanks for contacting us! We'll get back to you soon.")
        contactForm.reset()
      } else {
        // Check for errors
        const errorContainer = tempDiv.querySelector(
          '.errors, [class*="error"]'
        )
        if (errorContainer) {
          // Parse errors from the response
          const errorItems = errorContainer.querySelectorAll('li')
          const errors = {}

          errorItems.forEach((item) => {
            const text = item.textContent.trim()
            const match = text.match(/^(.+?)\s*-\s*(.+)$/)
            if (match) {
              const field = match[1].toLowerCase().replace(/\s+/g, '_')
              errors[field] = match[2]
            }
          })

          if (Object.keys(errors).length > 0) {
            showErrors(errors)
          } else {
            showMessage(
              'There was an error submitting your message. Please try again.',
              true
            )
          }
        } else {
          // If no specific error found, check if response contains error indicators
          if (
            responseText.includes('error') ||
            responseText.includes('Error')
          ) {
            showMessage(
              'There was an error submitting your message. Please try again.',
              true
            )
          } else {
            // Assume success if no errors found
            showMessage("Thanks for contacting us! We'll get back to you soon.")
            contactForm.reset()
          }
        }
      }
    } catch (error) {
      console.error('Contact form submission error:', error)
      showMessage(
        'There was an error submitting your message. Please try again.',
        true
      )
    } finally {
      // Reset loading state
      setSubmitButtonLoading(false)
    }
  }

  // Add click handler to submit button as primary method
  const submitButton = contactForm.querySelector('button[type="submit"]')
  if (submitButton) {
    submitButton.onclick = function (e) {
      console.log('Submit button clicked - preventing default')
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()

      // Call our AJAX handler
      handleAjaxSubmission()
      return false
    }
  }

  // Add submit event listener as backup
  contactForm.addEventListener('submit', async function (e) {
    console.log('Form submit event triggered')
    e.preventDefault()
    e.stopPropagation()

    console.log('Prevented default form submission')

    // AJAX is working - no more alerts needed!

    // Hide any previous messages
    hideMessage()

    // Show loading state
    setSubmitButtonLoading(true)

    try {
      const formData = new FormData(contactForm)
      console.log('Form data prepared:', formData)

      console.log('Sending AJAX request to /contact')
      const response = await fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
        },
      })

      console.log('Response received:', response.status, response.statusText)
      const responseText = await response.text()
      console.log('Response text:', responseText)

      // Create a temporary div to parse the response
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = responseText

      // Check for success message
      const successMessage = tempDiv.querySelector(
        '.success-message, [class*="success"]'
      )
      if (successMessage) {
        showMessage("Thanks for contacting us! We'll get back to you soon.")
        contactForm.reset()
      } else {
        // Check for errors
        const errorContainer = tempDiv.querySelector(
          '.errors, [class*="error"]'
        )
        if (errorContainer) {
          // Parse errors from the response
          const errorItems = errorContainer.querySelectorAll('li')
          const errors = {}

          errorItems.forEach((item) => {
            const text = item.textContent.trim()
            const match = text.match(/^(.+?)\s*-\s*(.+)$/)
            if (match) {
              const field = match[1].toLowerCase().replace(/\s+/g, '_')
              errors[field] = match[2]
            }
          })

          if (Object.keys(errors).length > 0) {
            showErrors(errors)
          } else {
            showMessage(
              'There was an error submitting your message. Please try again.',
              true
            )
          }
        } else {
          // If no specific error found, check if response contains error indicators
          if (
            responseText.includes('error') ||
            responseText.includes('Error')
          ) {
            showMessage(
              'There was an error submitting your message. Please try again.',
              true
            )
          } else {
            // Assume success if no errors found
            showMessage("Thanks for contacting us! We'll get back to you soon.")
            contactForm.reset()
          }
        }
      }
    } catch (error) {
      console.error('Contact form submission error:', error)
      showMessage(
        'There was an error submitting your message. Please try again.',
        true
      )
    } finally {
      // Reset loading state
      setSubmitButtonLoading(false)
    }
  })
}

// Initialize functions when DOM is ready
function initializeAll() {
  
  window.iachCustom.initStickyHeader();
  window.iachCustom.lazyloadBGimage();
  window.iachCustom.playVideo();
  window.iachCustom.initAcknowledgmentPopup();
  window.iachCustom.initCartBadgeUpdater();
  //window.iachCustom.initAjaxContactForm();
  
}

window.iachCustom.logLoaded();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAll);
} else {
  initializeAll();
}